(function () {
  var page_header_slider_v1_list = document.querySelectorAll('.js_social_feed_v1');

  for (var i = 0; i < page_header_slider_v1_list.length; i++) {
    const element = page_header_slider_v1_list[i]

    new Swiper(element, {
      spaceBetween: 40,
      slidesPerView: 1,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 992px
        991: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      },
      pagination: {
        el: ".js_social_feed_v1_pagination .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".js_social_feed_v1_nav .swiper-button-next",
        prevEl: ".js_social_feed_v1_nav .swiper-button-prev",
      },
    });
  }
})();
